import React from 'react';
import img from '../../../assets/images/mysimTravel.png';
import '../../seguranca/politicas/politicas.css';
import linha from '../../../assets/linha.png';

export default function ChipInternacional() {
  return (
    <article className="art-s mb-5 p-text">
      <section className="row m-0 sectionInit">
        <div className="c-init">
          <div className="c-init__text col-6  d-flex flex-column sect mt-5">
            <p className="fw-bolder text-decoration-underline">
              CHIP INTERNACIONAL – MY SIM TRAVEL
            </p>
            <p>
              A Ourominas (OM) é parceira da empresa de chip internacional My
              Sim Travel
            </p>
            <p>
              O Chip de Internet global My Sim Travel utiliza a mais avançada
              tecnologia GSM de Roaming Internacional, interligando uma rede
              global de operadoras de telefonia celular e em +200 países de
              todos os continentes do planeta. Após ativar pela primeira vez o
              seu SIM (chip), ele automaticamente se ajusta em cada país que
              visitar simplificando seu uso e sua vida. Não serão aplicados
              custos de ativação ou deslocamento em nenhum dos países de sua
              cobertura global.
            </p>
            <div className="div-line">
              <img src={linha} alt="linha de separação"></img>
            </div>
          </div>
          <div className="col-6 c-init__images">
            <img src={img} className="images" alt="grupo-om"></img>
          </div>
        </div>{' '}
        <section className="mt-4 sect">
          <p className=" mt-5 my-3  fw-bolder">PERGUNTAS FREQUENTES</p>
          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">POR QUE USAR O MY SIM TRAVEL?</summary>
            <ul>
              <li>CHIP Internet Global 4G Pré-Pago;</li>
              <li>Não perde a validade. Tarifas em Reais;</li>
              <li>Mantém o número do WhatsApp do Brasil;</li>
              <li>Aceito globalmente em +200 países;</li>
              <li>Oferece os serviços de DADOS / VOZ / SMS;</li>
              <li>Planos de Internet 1GB / 5GB / 10GB / 20GB;</li>
              <li>Américas / Europa / Ásia / África / Oceania;</li>
              <li>Suporte 24hrs x 365 dias em Português do Brasil;</li>
              <li>Compre e teste aqui no Brasil antes da sua viagem;</li>
              <li>Sem tarifa de manutenção mensal;</li>
              <li>Recarregue com nosso aplicativo My Sim Travel FORYOU;</li>
              <li>Compatível com celular desbloqueado (iPhone, Android).</li>
            </ul>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">COMO FUNCIONAM AS TARIFAS? </summary>
            <p className="mt-4">
              O mysimtravel é um cartão SIM Pré-Pago. Sem custos de ativação ou
              deslocamento, sem consumo mínimo exigido. As tarifas são em Reais
              (BRL$).
            </p>
            <ul>
              <li>
                Tarifas de VOZ, SMS e DADOS, dependendo do país em que você se
                encontra no momento da sua utilização.
                <p>VOZ – Chamadas feitas ou recebidas. </p>
                <p>SMS – Mensagens de texto enviadas ou recebidas. </p>
                <p>DADOS – Consumo de Internet. </p>
              </li>
              <li>
                Tarifas de Voz
                <p>
                  As tarifas SMS possuem apenas 02 componentes. O país onde você
                  se encontra para enviar ou receber uma mensagem SMS (até 160
                  caracteres); e se a mensagem é enviada entre SIM CARDs
                  mysimtravel ou com qualquer outro dispositivo.
                </p>
                <ul>
                  <li>
                    Pacotes de DADOS (Internet)
                    <ol>
                      <li>Possuem diversas capacidades (10MB a 5GB).</li>
                      <li>Tem prazo de validade específico após ativados.</li>
                      <li>
                        Poderá ser consumido antes do prazo e ativar outro
                        pacote.
                      </li>
                      <li>
                        Dados não consumidos dentro do prazo serão perdidos.
                      </li>
                      <li>É possível ativar um único pacote de cada vez. </li>
                    </ol>
                  </li>
                </ul>
              </li>
              <li className="mt-4">
                Créditos
                <p>
                  Nossas tarifas são em Reais (BRL$),com impostos inclusos.{' '}
                </p>
                <p>Não existe cobrança de manutenção mensal. </p>
                <p>
                  Os créditos não perdem a validade até serem utilizados com
                  Chamadas, Internet ou SMS.
                </p>
                <p>
                  Os Pacotes de Internet por sua vez possuem validade após serem
                  ativados.
                </p>
                <p>
                  Após o período de um (01) ano sem utilizar, o usuário será
                  contactado para definir se quer continuar ou finalizar o uso.
                  Poderá utilizar os créditos e depois cancelar o Chip.
                </p>
              </li>
              <li>
                Exemplo: Como calcular saldo:
                <p>
                  <table
                    style={{
                      border: '1px solid black',
                      borderCollapse: 'collapse',
                      width: '100%',
                    }}
                  >
                    <tr>
                      <td style={{ border: '1px solid black', padding: '8px' }}>
                        <strong>Saldo inicial:</strong>
                      </td>
                      <td style={{ border: '1px solid black', padding: '8px' }}>
                        R$ 300,00
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid black', padding: '8px' }}>
                        <strong>Ativar Pacote 1GB:</strong>
                      </td>
                      <td style={{ border: '1px solid black', padding: '8px' }}>
                        -R$ 92,00
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid black', padding: '8px' }}>
                        <strong>10 min ligação:</strong>
                      </td>
                      <td style={{ border: '1px solid black', padding: '8px' }}>
                        -R$ 15,00
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid black', padding: '8px' }}>
                        <strong>= Novo Saldo:</strong>
                      </td>
                      <td style={{ border: '1px solid black', padding: '8px' }}>
                        R$ 192,00
                      </td>
                    </tr>
                  </table>
                </p>
              </li>
            </ul>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              QUAI SÃO OS PLANOS DE INTERNET?{' '}
            </summary>
            <p className="mt-4">
              Clique aqui para saber os planos disponíveis e o pacote mais
              adequado para seu(s) destino(s).{' '}
              <a href="https://mysimtravel.com.br/tarifas/">
                (https://mysimtravel.com.br/tarifas/)
              </a>
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              TARIFAS GLOBAIS VOZ / SMS / EXTRA.
            </summary>
            <p className="mt-4">
              Tarifas são aplicadas considerando o país onde fisicamente o CHIP
              se encontra. Clique aqui para saber as tarifas de cada país.
              <a href="https://mysimtravel.com.br/voz-sms/">
                (https://mysimtravel.com.br/voz-sms/)
              </a>
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              COMO CONFIGURAR E ATIVAR O CHIP 4G O MEU CELULAR.{' '}
            </summary>
            <p className="mt-4">
              Para configurar e ativar o chip 4G no seu celular são apenas 3
              passos. Clique aqui para ser direcionado ao manual.
              <a href="https://mysimtravel.com.br/como-funciona-mysimtravel-4g/">
                (https://mysimtravel.com.br/como-funciona-mysimtravel-4g/)
              </a>
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              COMO CONFIGURAR E ATIVAR O CHIP 3G O MEU CELULAR.
            </summary>
            <p className="mt-4">
              Para configurar e ativar o chip 3G no seu celular são apenas 3
              passos. Clique aqui para ser direcionado ao manual.
              <a href="https://mysimtravel.com.br/como-funciona-mysimtravel-3g">
                (https://mysimtravel.com.br/como-funciona-mysimtravel-3g)
              </a>
            </p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">COMO MANTER O MEU WHATSAPP?</summary>
            <p className="mt-4">
              O Chip Internacional permite que você escolha entre registrar um
              NOVO número ou MANTER seu número atual. Após instalar o CHIP e
              chamar o WhatsApp pela primeira vez, irá aparecer esta mensagem
              para você escolher.
            </p>
            <p style={{ fontWeight: 'bold' }}>
              Se deseja alterar o número do WhatsApp, siga esses passos:
            </p>
            <p>
              Vá em WhatsApp &gt; Botão Menu &gt; Configurações &gt; Conta &gt;
              Mudar o número.{' '}
            </p>
            <p>Insira o seu número de telefone antigo no campo superior. </p>
            <p>Insira o seu número de telefone novo no campo inferior. </p>
            <p>Toque em Concluído no topo da tela.</p>
            <p>Você será solicitado a verificar o seu número de telefone.</p>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              DICAS DE ECONOMIA DE DADOS PARA IPHONE.
            </summary>
            <p className="mt-4">
              Consulte o manual do fabricante de seu celular iPhone para efetuar
              corretamente suas alterações.
            </p>
            <p>
              É de responsabilidade do usuário as alterações efetuadas na
              configuração e a preservação dos dados armazenados em seu
              equipamento, assim como a configuração de replicação de dados,
              como atualizações em segundo plano, replicações em nuvem ou
              aplicativos que enviam ou recebem notificações via transmissão de
              dados ou SMS.
            </p>
            <ol>
              <li>
                Em Ajustes -&gt; Celular Rolar a tela até o final Assistência
                WIFI – DESATIVAR iCloud Drive – DESATIVAR
              </li>
              <li>
                Em Ajustes -&gt; Geral Atualização em 2o Plano – Somente WIFI
              </li>
              <li>
                Em Ajustes -&gt; iTune & Apps Uso de Dados celulares – Desativar
              </li>
            </ol>
            <p>Informação técnicas do Chip My Sim Travel: </p>
            <ul>
              <li>Não gera ou consome dados sozinho; </li>
              <li>Não envia SMS automaticamente; </li>
              <li>
                Não possui restrições de velocidade de download / upload.{' '}
              </li>
            </ul>
          </details>

          <details className="mb-2 pb-2 border-bottom">
            <summary className="fw-bold">
              O QUE É E COMO FUNCIONA O SERVIÇO DE GEO LOCAIZAÇÃO GLOBAL?
            </summary>
            <p className="mt-4">
              O mundo não é mais o mesmo, e precisamos nos preocupar cada vez
              mais com nossa segurança pessoal, o Chip Internacional My Sim
              Travel apresenta esta nova funcionalidade para todos os seus
              clientes: Serviço de GEO LOCALIZAÇÃO Global.
            </p>
            <p>- O QUE É? </p>
            <p>
              Funcionalidade única e especial do Chip Internacional My Sim
              Travel para todos os viajantes que se preocupam com Segurança em
              suas viagens pelo mundo a fora. O Chip pode ser programado para
              emitir alertas de posicionamento global, fornecendo coordenadas
              globais de Longitude / Latitude.{' '}
            </p>
            <p>- COMO FUNCIONA? </p>
            <p>
              O serviço de Geo Localização Global My Sim Travel é opcional e
              está disponível para ativação em todos os Chips My Sim Travel .
              Após ativar o serviço, o Chip emite alertas por 30 dias (temos
              planos de 100 e 1500 alertas por 30 dias). Estes alertas, são
              coordenadas geográficas (Ex: 13.69491 100.53346) que podem ser
              capturadas a qualquer momento. Usando o Google Maps por exemplo,
              imediatamente você sabe a região onde se encontra. O Chip My Sim
              Travel usa a triangulação de antenas de telefonia celular e
              posiciona você o mais próximo possível. O Serviço não usa e não
              consome dados do pacote de Internet. É necessário apenas que o
              celular esteja ligado e registrado na operadora de telefonia
              celular da região onde você se encontra. São +200 países em todo
              mundo onde nosso serviço pode ser utilizado.{' '}
            </p>
            <p>- QUANTO CUSTA? </p>
            <p>
              Custa apenas uma única tarifa de ativação: Plano 100 alertas
              R$9,90 / 30 dias, Plano 1500 alertas R$29,90 / 30 dias. Pode ser
              renovado quantas vezes desejar. É necessário ter saldo disponível
              no Chip My Sim Travel para ativação. É compatível com qualquer
              celular (iOS/Android) desbloqueado.
            </p>
            <p>- A QUEM SE DESTINA? </p>
            <p>
              A todo viajante que se preocupa com sua segurança e deseja
              compartilhar sua geo-localização.
            </p>
          </details>
        </section>
      </section>
    </article>
  );
}
